// typeof any so that it we don't have to cast when comparing a result to the error object
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export var errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/util/errorObject.js
// module id = null
// module chunks = 